import { useMutation } from '@tanstack/react-query';
import { ApiEntryFilters } from 'api/data/filters/types';
import { makeRequest } from 'features/entry-form-v2/data/makeRequest';
import { CodelistRecord } from 'features/codelist/domain/codelistRecordSchema';

export type ExportCodelistResponse = {
	records: CodelistRecord[];
};

const exportCodelist = (args: { projectId: string; filters: ApiEntryFilters }) => {
	return makeRequest<ExportCodelistResponse>({
		method: 'exportCodelist',
		service: 'cde',
		data: {
			projectId: args.projectId,
			filters: args.filters
		}
	});
};

export const useExportCodelistMutation = (args: { projectId: string }) => {
	return useMutation({
		mutationFn: (filters: ApiEntryFilters) =>
			exportCodelist({ projectId: args.projectId, filters })
	});
};
